const groupingBag = 'https://d222i9ppxs2fqe.cloudfront.net/groupingBag_opt.png';
const harishImg = 'https://d222i9ppxs2fqe.cloudfront.net/harish_Img.png';
const ragothImg = 'https://d222i9ppxs2fqe.cloudfront.net/ragoth_Img.png';
const kiruImg = 'https://d222i9ppxs2fqe.cloudfront.net/kiru_img.png';
const gingerChilli = 'https://d222i9ppxs2fqe.cloudfront.net/gingerChilli.png';
const chopChef = 'https://d222i9ppxs2fqe.cloudfront.net/chopChef_opt.gif';

import { CHEF_ASSET } from '@utils/data';
import {
  aboutUsPageCoFounderContentType,
  aboutUsPagemiddleContentType,
} from '@utils/types';

const headerContent: {
  title: string;
  firstDescription: string;
  secondDescription: string;
} = {
  title: 'We bring authentic Indian flavors straight from the source.',
  firstDescription:
    'As diaspora, we are always searching for that sense of belonging and a plate of our favorite comfort food is often the answer. However, creating those robust flavors from home is often difficult. Finding them can be impossible.',
  secondDescription:
    'We wanted to easily access the recipes we grew up with.The Cumin Club was our solution! ',
};

const middleSectionContent: aboutUsPagemiddleContentType[] = [
  {
    id: 1,
    title: 'Regional Ingredients',
    description:
      'All our dishes use regional ingredients and spices specific to every cuisine of India. You won’t catch us mixing our Kashmiri chillies with our byadagis!',
    icon: gingerChilli,
    alt: 'gingerChilli',
  },
  {
    id: 2,
    title: 'Made In India',
    description:
      'Who better to prepare a regional dish than an expert chef from that very region? Our team of chefs hail from all over India and bring their expertise into creating that perfect authentic flavor. ',
    icon: CHEF_ASSET,
    alt: 'CHEF_ASSET',
  },
  {
    id: 3,
    title: 'Clean Food, Always',
    description:
      'We don’t do preservatives, period. What we do are all-natural ingredients and good-for-you food. Freeze drying technology lets our meals retain every ounce of flavor and nutrition, so we don’t add a single extra thing that shouldn’t be there. ',
    icon: groupingBag,
    alt: 'groupingBag',
  },
];

const coFounderSectionContent: aboutUsPageCoFounderContentType[] = [
  {
    id: 1,
    icon: ragothImg,
    alt: 'ragothImg',
    bgColor: 'turmeric.main',
    titleColor: 'cinnamon.main',
    descriptionColor: 'garamMasala.main',
    name: 'Ragoth Bala',
    description: [
      { title: 'Hometown', content: 'Coimbatore, Tamil Nadu, India' },
      { title: 'Favorite Dish', content: 'Dal Chawal with tomato pickle' },
      {
        title: 'Superpower',
        content: 'Always learning enough to be impactful',
      },
    ],
    thought:
      'When I first moved to the US, I couldn’t find the dishes I grew up eating. I had to find a way to fix that.',
  },
  {
    id: 2,
    icon: harishImg,
    alt: 'harishImg',
    bgColor: 'cinnamon.main',
    titleColor: 'turmeric.main',
    descriptionColor: 'whitePepper.main',
    name: 'Harish Visweswaran',
    description: [
      { title: 'Hometown', content: 'Coimbatore, Tamil Nadu, India' },
      { title: 'Favorite Dish', content: 'Ghee dosa with all the condiments' },
      {
        title: 'Superpower',
        content: 'My belief that one’s destiny is in their own control',
      },
    ],
    thought:
      'Everyone in the world should get a chance to try Indian cuisine, and I hope The Cumin Club is their first dish.',
  },
  {
    id: 3,
    icon: kiruImg,
    alt: 'kiruImg',
    bgColor: 'whitePepper.main',
    titleColor: 'garamMasala.main',
    descriptionColor: 'cinnamon.main',
    name: 'Kiru Rajagopal',
    description: [
      { title: 'Hometown', content: 'Coimbatore, Tamil Nadu, India' },
      { title: 'Favorite Dish', content: 'Idiyappam with vegetable stew' },
      {
        title: 'Superpower',
        content: 'My ability to keep things simple',
      },
    ],
    thought:
      'Indian food is as diverse as its culture. It brings me joy to work with hyper local ingredients and make truly authentic Indian dishes available around the world.',
  },
];

export { headerContent, middleSectionContent, coFounderSectionContent };
